module.exports = __webpack_public_path__ + "img/linkedin-icon.5febf3fd.svg";